import { FileInput } from 'lucide-react';
import { useState, type ReactElement } from 'react';

import { ConfirmModal } from '@/components/ui/ConfirmModal';
import { useToast } from '@/components/ui/toast';

import { onlineEditErrorText } from '../online-errors';
import { useTakeLmsVersion } from '../use-online-editing';

interface Props {
  entryId: string;
  /** Tomada la versión: el panel deja de ofrecer la acción. */
  onTaken: () => void;
}

/** Acción de Calidad cuando el gestor documental tiene una versión cargada fuera del QMS:
 *  la toma como borrador (reemplaza el archivo de SharePoint) tras confirmar. */
export function TakeLmsVersion({ entryId, onTaken }: Props): ReactElement {
  const take = useTakeLmsVersion();
  const { showToast } = useToast();
  const [open, setOpen] = useState(false);

  const confirm = (): void => {
    take.mutate(
      { entryId },
      {
        onSuccess: (data) => {
          setOpen(false);
          onTaken();
          showToast(
            `Se tomó la versión ${data.lmsVersion} del gestor documental. Ya puedes editar en Office.`,
          );
        },
      },
    );
  };

  return (
    <>
      <button
        type="button"
        className="btn mut sm"
        onClick={() => {
          take.reset();
          setOpen(true);
        }}
      >
        <FileInput size={14} aria-hidden="true" />
        Tomar versión del gestor
      </button>
      <ConfirmModal
        open={open}
        title="Tomar la versión del gestor documental"
        message="El borrador en Microsoft 365 se reemplaza por la versión cargada en el gestor documental y se retiran los accesos abiertos. Lo editado hasta ahora queda en el historial de versiones de SharePoint."
        confirmLabel="Tomar versión"
        destructive
        busy={take.isPending}
        error={
          take.isError ? onlineEditErrorText(take.error, 'No se pudo tomar la versión.') : null
        }
        onConfirm={confirm}
        onCancel={() => setOpen(false)}
      />
    </>
  );
}
